import type { MediaItem } from "@/features/media/types";
import { SafeImage } from "@/components/ui/SafeImage";

export function ImagePreview({ item, className = "aspect-video w-full" }: { item: MediaItem; className?: string }) {
  return (
    <div className={`${className} overflow-hidden rounded-md border border-cyan-300/15 bg-black/40`}>
      <SafeImage src={item.url} alt={item.altText || item.originalName} fallbackLabel="Image unavailable" className="h-full w-full object-contain" loading="lazy" />
    </div>
  );
}
